webpackJsonp([448],{

/***/ 1718:
/***/ (function(module, exports, __webpack_require__) {

var disposed = false
var Component = __webpack_require__(67)(
  /* script */
  __webpack_require__(903),
  /* template */
  __webpack_require__(2168),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)
Component.options.__file = "/home/runner/work/vux/vux/docs/node_modules/v-markdown-loader/_cache/debounce-throttle-305.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] debounce-throttle-305.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-3cb05801", Component.options)
  } else {
    hotAPI.reload("data-v-3cb05801", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

module.exports = Component.exports


/***/ }),

/***/ 2168:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h2', [_vm._v("debounce")]), _vm._v(" "), _c('div', {
    staticClass: "warning"
  }, [_c('p', [_vm._v("请注意了解 "), _c('code', [_vm._v("debounce")]), _vm._v(" 和 "), _c('code', [_vm._v("throttle")]), _vm._v(" 的区别。如果尚不清楚，请"), _c('code', [_vm._v("google")]), _vm._v("之。")])]), _vm._v(" "), _c('pre', {
    staticClass: "hljs"
  }, [_c('code', [_c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("import")]), _vm._v(" { debounce } "), _c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("from")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'vux'")]), _vm._v("\n\ndebounce(func, [wait="), _c('span', {
    staticClass: "hljs-number"
  }, [_vm._v("0")]), _vm._v("], [options={}])\n")])]), _vm._v(" "), _c('p', [_c('a', {
    attrs: {
      "href": "https://lodash.com/docs/#debounce"
    }
  }, [_vm._v("详细文档")])]), _vm._v(" "), _c('h2', [_vm._v("throttle")]), _vm._v(" "), _c('pre', {
    staticClass: "hljs"
  }, [_c('code', [_c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("import")]), _vm._v(" { throttle } "), _c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("from")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'vux'")]), _vm._v("\n\nthrottle(func, [wait="), _c('span', {
    staticClass: "hljs-number"
  }, [_vm._v("0")]), _vm._v("], [options={}])\n")])]), _vm._v(" "), _c('p', [_c('a', {
    attrs: {
      "href": "https://lodash.com/docs/#throttle"
    }
  }, [_vm._v("详细文档")])])])
}]}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-3cb05801", module.exports)
  }
}

/***/ }),

/***/ 770:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(1718);

/***/ }),

/***/ 903:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  head: { "title": "debounce | VUX - Vue 移动端 UI 组件库", "ignoreSuffixChar": "|" }
});

/***/ })

});


// WEBPACK FOOTER //
// 448.28e050cf.js